// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HXQOm","userName":"Header_userName__q0v6S","userLogo":"Header_userLogo__rcnPO"};